module.exports = __webpack_public_path__ + "static/CalibreSemibold-0cf4497b765aa0466ead3d66f188835f.woff";